<template>
    <div class="" v-if="data">
        <h2>Спортивные достижения кадет</h2>
        <table v-if="data">
            <tr>
                <td>Количество обучающихся, сдавших нормы Всероссийского физкультурно-спортивного комплекса «Готов к труду и обороне» на золотой знак отличия</td>
                <td>{{data.pupilsGtoGold}}</td>
            </tr>
            <tr>
                <td>Количество обучающихся, сдавших нормы Всероссийского физкультурно-спортивного комплекса «Готов к труду и обороне» на серебряный знак отличия</td>
                <td>{{data.pupilsGtoSilver}}</td>
            </tr>
            <tr>
                <td>Количество обучающихся, сдавших нормы Всероссийского физкультурно-спортивного комплекса «Готов к труду и обороне» на бронзовый знак отличия</td>
                <td>{{data.pupilsGtoBronze}}</td>
            </tr>
            <tr>
                <td>Наличие победителей и призеров Спартакиады кадет</td>
                <td>{{data.pupilsOlympicsCadet}}</td>
            </tr>
            <tr>
                <td>Количество кадет имеющих 1, 2, 3 спортивный разряд</td>
                <td>{{data.pupilsSportsCategory}}</td>
            </tr>
            <tr>
                <td>Количество кадет, имеющих 1, 2, 3 юношеский разряд</td>
                <td>{{data.pupilsJuniorLevel}}</td>
            </tr>
            <tr>
                <td>Количество кадет, имеющих звание «Кандидат в мастера спорта России» или «Мастер спорта России»</td>
                <td>{{data.pupilsMasterSport}}</td>
            </tr>
        </table>
    </div>
</template>


<script>
    import Request from 'superagent';
    export default{

        data(){
            return {
                data: false
            };
        },


        created(){
            this.getData();

        },


        methods:{
            getData(){
                var $this = this;
                var path = this.$store.state.api+ this.$store.state.apiCadetSport +"?eoId="+this.$store.state.eoId;
                Request
                    .get(path)
                    .then((res)=>{
                        if(res.status == 200){
                            if(res.body.result == "success"){
                                $this.data = res.body.data;
                            }
                        }
                });
            },
        }
    }
</script>


<style>

</style>
